import React, { useEffect, useMemo } from 'react';
import { useAiRovoCurrentRouteConfiguration } from '@jira/ai-rovo_actions-store/src/useAiRovoCurrentRouteConfiguration.tsx';
import { useOrgId } from '@jira/router-resources__navigation-organization-id/src/useOrgId.tsx';
import { AISmartButton } from '@atlassian/ai-smart-button/ai-smart-button';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useConversationAssistantSidebarApi } from '@jira/platform__conversation-assistant/src/useConversationAssistantSidebarApi.tsx';
import { useAISmartButtonActions } from '@atlassian/ai-smart-button-api/ai-smart-button-store';
import type { ConversationAssistantConfig } from '@atlassian/conversation-assistant/types';
import { expVal } from '@atlassian/jira-feature-experiments';

export const AiRovoButtonWrapperRefresh = (): React.JSX.Element => {
	const cloudId = useCloudId();
	const { data: orgId } = useOrgId();
	const configuration = useAiRovoCurrentRouteConfiguration();
	const sidebarApi = useConversationAssistantSidebarApi({});
	const { setNudges } = useAISmartButtonActions();

	useEffect(() => {
		setNudges(configuration.nudges ?? []);
	}, [configuration.nudges, setNudges]);

	// Match to logic in platform/packages/insights-ai-platform/ai-smart-button/src/ui/ai-mini-modal/main.tsx
	// and jira/src/packages/ai-rovo/button/src/AiRovoButtonWrapperRefresh.tsx
	const conversationAssistantConfig = useMemo(
		(): ConversationAssistantConfig | undefined =>
			expVal('prevent_abort_jira_rovo_chat', 'isEnabled', false)
				? {
						displaySubmitFlag: true,
						siteId: cloudId,
						product: 'jira',
						orgId,
						assistanceServiceConfig: {
							headers: {
								'x-issynthetic-traffic': 'false',
								'X-Cloudid': cloudId,
							},
							baseUrl: '/gateway/api/assist',
						},
						preventAbortRequestsOnStagingModalClose: true,
						preventAbortRequestsOnStandaloneChatClose: true,
					}
				: undefined,
		[cloudId, orgId],
	);

	return (
		<AISmartButton
			product="jira"
			cloudId={cloudId}
			orgId={orgId}
			isNav4Enabled
			sidebarApi={sidebarApi}
			productPage="jira"
			getActions={configuration.getActions}
			tags={configuration.tags}
			uiConfig={configuration.uiConfig}
			prioritizeCustomActionResults={configuration.prioritizeCustomActionResults}
			conversationAssistantConfig={conversationAssistantConfig}
		/>
	);
};
